import { Button, type ButtonProps } from 'antd';
import { type ReactNode, useState } from 'react';
import { IconClose } from './Icon';
import { Tristate } from './utils/tristateTask';

type Props = ButtonProps & {
  onClick?: () => Promise<unknown>;
  children?: ReactNode;
};

export function AsyncButton({ onClick, children, disabled, ...props }: Props) {
  const [status, setStatus] = useState<Tristate>(Tristate.NORMAL);

  const handleClick = async () => {
    setStatus(Tristate.SPINNING);
    try {
      await onClick?.();
      setStatus(Tristate.NORMAL);
    } catch {
      setStatus(Tristate.FAILURE);
      setTimeout(() => setStatus(Tristate.NORMAL), 2000);
    }
  };

  let { icon } = props;
  if (status === Tristate.FAILURE) icon = <IconClose />;

  return (
    <Button
      {...props}
      onClick={onClick ?? handleClick}
      loading={status === Tristate.SPINNING}
      icon={icon}
      disabled={disabled || status === Tristate.SPINNING}
    >
      {children}
    </Button>
  );
}
